import {call, baseUrl} from 'brave-api/base'
import QueryString from 'brave-utils/query-string'
export default {
  login: async function (payload) {
    let qs = new QueryString(window.location.search)
    let params = qs.toSingleValueDict()
    payload = Object.assign(payload, {
      login: 1,
      robot: 1,
      brand: 'bravenet',
      brandref: 'bravenet',
      cart_hash: (params.cart_hash) ? params.cart_hash : '',
      template_id: (params.template_id) ? params.template_id : '',
      rememberme: (payload.rememberme)
        ? 1
        : 0,
      service_name: (params.from)
        ? params.from
        : '',
      redirect_to: params.redirect_to
    })


    return call('POST',
      `${baseUrl}/global/login.php`,
      payload
    )
  },
  register: async function (payload) {
    let qs = new QueryString(window.location.search)
    let params = qs.toSingleValueDict()
    payload = Object.assign(payload, {
      "form_key": "ignore",
      "form_name": "signup_form",
      "signup_form_submitted": 1,
      "email_bnet": "",
      "signup_step": false,
      "brandref": "bravenet",
      "cart_hash": (params.cart_hash) ? params.cart_hash : '',
      template_id: (params.template_id) ? params.template_id : '',
      "robot": 1,
      "freebies": 0,
      "specialoffers": 0,
      "tipsandtricks": 0,
      "resources": 0,
      "email_bn": 0,
      "tosagree": 1,
      "service_name": (params.from)
        ? params.from
        : '',
      redirect_to: params.redirect_to
    })

    return call('POST',
      `${baseUrl}/signup/signup.php`,
      payload,
    )
  },
  checkUsername: async function (payload) {
    return call('POST',
      `${baseUrl}/checkuserid.php`,
      payload
    )
  },
  lostpassword: async function (payload) {
    let qs = new QueryString(window.location.search)
    let params = qs.toSingleValueDict()
    payload = Object.assign(payload, {
      "form_key": "ignore",
      "form_name": "login_form",
      "login_form_submitted": 1,
      "email_bnet": "",
      "login_form_fp": "ignore",
      "brandref": "bravenet",
      "robot": 1,
      "freebies": 0,
      "specialoffers": 0,
      "tipsandtricks": 0,
      "resources": 0,
      "email_bn": 0,
      "tosagree": 1,
      "service_name": (params.from)
        ? params.from
        : ''
    })

    return call('POST',
      `${baseUrl}/global/lostpassword.php`,
      payload,
    )
  }
}
